// extracted by mini-css-extract-plugin
export default {"container":"BNVmy5","tooltipContainer":"URrhy1"};